import PropTypes from 'prop-types';
import React from 'react';
import Script from 'next/script';

const PixelAnalytics = ({ service }) => (
	<Script
		async
		src={`https://culturaltracking.ru/static/js/spxl.js?pixelId=${service.analyticsId}`}
		data-pixel-id={service.analyticsId}
		strategy="afterInteractive"
	/>
);

PixelAnalytics.propTypes = {
	service: PropTypes.object.isRequired
};

export default PixelAnalytics;
